export default "__VITE_ASSET__Bxt32FBf__"